import { Link } from 'react-router-dom';
import NewsletterForm from './NewsletterForm';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-fire-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">网报吃瓜</span>
            </div>
            <p className="text-sm text-background-200/80 leading-relaxed max-w-sm">
              把分散的网络讨论聚到一起，用温度榜、立场分布和评论流，帮你在几分钟内跟上舆情风向。
            </p>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="text-background-200/80 hover:text-accent-300 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/topics" className="text-background-200/80 hover:text-accent-300 transition-colors cursor-pointer">
                  热议广场
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-200/80 hover:text-accent-300 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-200/80 hover:text-accent-300 transition-colors cursor-pointer">
                  内容原则
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">联系方式</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2 text-background-200/80">
                <i className="ri-mail-line"></i>
                <span>hello@wangbaochigua.com</span>
              </li>
              <li className="flex items-center gap-2 text-background-200/80">
                <i className="ri-time-line"></i>
                <span>每日 09:00 更新</span>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">热点周报订阅</h4>
            <NewsletterForm />
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-100/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-300/70">
            © 2026 网报吃瓜 · 内容聚合与观点整理，仅供参考讨论
          </p>
          <p className="text-xs text-background-300/70">
            理性吃瓜，尊重每一种立场
          </p>
        </div>
      </div>
    </footer>
  );
}